module.exports = __webpack_public_path__ + "static/media/cd.b8dae5b7.svg";